var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("w-input", {
    attrs: {
      password: "",
      value: _vm.value,
      "has-error": _vm.hasError,
      label: _vm.label,
      fancy: _vm.fancy,
      disabled: _vm.disabled,
      autofocus: _vm.autofocus,
      placeholder: _vm.placeholder,
    },
    on: {
      input: function ($event) {
        return _vm.onInput($event)
      },
      blur: function ($event) {
        return _vm.$emit("blur")
      },
      keyup: function ($event) {
        return _vm.$emit("keyup", $event)
      },
      keydown: function ($event) {
        return _vm.$emit("keydown", $event)
      },
    },
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }